import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/@headlessui/react/dist/components/popover/popover.js");
;
import(/* webpackMode: "eager", webpackExports: ["Transition"] */ "/opt/build/repo/node_modules/@headlessui/react/dist/components/transition/transition.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
